import React from 'react';
import { Row, Col, Image, Space, Typography, Grid } from 'antd';
import Pict from '../../assets/img/wchss-pict-1.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;

function Welcome() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Pict}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={24}>
              <Space direction="vertical" size={16}>
                <Space direction="vertical" size={-8}>
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Welcome to The 1st World Conference</Text>
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>On Health and Social Sciences</Text>
                </Space>
                <Space direction="vertical" size={16}>
                  <Text style={{ fontSize: 15 }}>"In implementing the three pillars (tri dharma) of higher education, Binawan University, supported by the fields of health and social sciences, would like to provide solutions to problems affecting society. Gathering experts, researchers, academics, practitioners, students, and policymakers in one conference can be a medium for sharing knowledge and experiences to solve and provide solutions to many problems in dealing with the crisis during a pandemic and prepare for future situations."</Text>
                  <Text style={{ fontSize: 15 }}>"The First World Conference on Health and Social Science is the first international conference involving 3 Faculties of Binawan University. It is planned as an annual event. This activity is supported by DRTPM (The Directorate of Research, Technology, and Community Services) funding."</Text>
                  <Text style={{ fontSize: 15 }}>"This activity aims to develop and evaluate research-based interventions to improve public health, reduce social inequalities in health, and communicate research results and implications to a wide range of audiences."</Text>
                </Space>
              </Space>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={128} style={{ backgroundColor: '#fff' }}>
            <Col span={14}>
              <Space direction="vertical" size={32}>
                <Space direction="vertical" size={-8}>
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Welcome to The 1st World Conference</Text>
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>On Health and Social Sciences</Text>
                </Space>
                <Space direction="vertical" size={16}>
                  <Text style={{ fontSize: 15 }}>"In implementing the three pillars (tri dharma) of higher education, Binawan University, supported by the fields of health and social sciences, would like to provide solutions to problems affecting society. Gathering experts, researchers, academics, practitioners, students, and policymakers in one conference can be a medium for sharing knowledge and experiences to solve and provide solutions to many problems in dealing with the crisis during a pandemic and prepare for future situations."</Text>
                  <Text style={{ fontSize: 15 }}>"The First World Conference on Health and Social Science is the first international conference involving 3 Faculties of Binawan University. It is planned as an annual event. This activity is supported by DRTPM (The Directorate of Research, Technology, and Community Services) funding."</Text>
                  <Text style={{ fontSize: 15 }}>"This activity aims to develop and evaluate research-based interventions to improve public health, reduce social inequalities in health, and communicate research results and implications to a wide range of audiences."</Text>
                </Space>
              </Space>
            </Col>
            <Col span={10}>
              <Image
                width={'100%'}
                src={Pict}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Welcome